export default __webpack_public_path__ + "static/media/arrow-right.bce1ce3e.svg";